import { Slider, typographyHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { formatCommuteTimeForDisplay } from '../../helpers/formatCommuteTimeForDisplay';

const COMMUTE_TIME_MIN = 5;
const COMMUTE_TIME_MAX = 90;
const COMMUTE_TIME_STEP = 5;

const CommuteTime = styled(Slider)`
  .commuteTimeLabel {
    ${typographyHelper('subtitle02')}
  }
`;
export const CommuteTimeInput: FunctionComponent<{
  commuteTime: number;
  onChange: (time: number) => void;
}> = ({ commuteTime, onChange }) => {
  return (
    <CommuteTime
      id="commute_time"
      min={COMMUTE_TIME_MIN}
      max={COMMUTE_TIME_MAX}
      dangerouslySetClassNames={{ labelClassNames: { label: 'commuteTimeLabel' } }}
      step={COMMUTE_TIME_STEP}
      label={`Travel time under ${formatCommuteTimeForDisplay(commuteTime)}`}
      value={commuteTime}
      onChange={(e) => onChange(Number(e.target.value))}
    />
  );
};
